// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5c830e18","404":"3ac5f455"}[chunkId] + ".chunk.js";
};